const isDev = () => process.env.ENV === "dev" || process.env.LOCAL_DEV;
const isDvm = () => process.env.ENV === "dvm";
const isTsm = () => process.env.ENV === "tsm";
const isTsr = () => process.env.ENV === "tsr";
const isProd = () => process.env.ENV === "prod" || process.env.ENV === "prd";
const isClusterEnv = () => isDvm() || isTsm() || isTsr() || isProd();

const canUseDom = () =>
  !!(
    typeof window !== "undefined" &&
    window.document &&
    window.document.createElement
  );

const isNode = !canUseDom();
const isBrowser = canUseDom();

module.exports = {
  isDev,
  isDvm,
  isTsm,
  isTsr,
  isProd,
  isClusterEnv,
  isNode,
  isBrowser,
  canUseDom,
};
